<template>
    <sav-template title="" :back-button="false" :navigation-bar="false">
        <div class="2xl:w-1/2 2xl:mx-auto">
            <div v-html="$t('bienvenue.description')"></div>
            <div class="my-rounded bg-white shadow p-6 mt-4">
                <!-- Connexion obligatoire avant le formumlaire -->
                <template v-if="$companyTool.confFile().login_oblig == 1">
                    <router-link :to="{ name: 'user.login'}" class="text-gray-900" style="text-decoration: none !important;">
                        <div test-id="button-go-to-login" class="flex justify-between items-center border-b p-6 hover:bg-gray-50 rounded-t-xl duration-200">
                            <div>
                                <b>{{$tt('Je possède déjà un compte')}}</b>
                                <small class="block text-gray-600">{{$t('bienvenue.je_possede_deja_un_compte')}}</small>
                            </div>
                            <i class="fas fa-caret-right"></i>
                        </div>
                    </router-link>
                    <router-link :to="{ name: $companyTool.confFile().pro_particulier == 1 ? 'user.login.actors' : 'user.register'}" class="text-gray-900" style="text-decoration: none !important;">
                        <div test-id="button-go-to-form" class="flex justify-between items-center p-6 hover:bg-gray-50 rounded-b-xl duration-200">
                            <div class="pr-4">
                                <b>{{$tt('Je ne possède pas de compte')}}</b>
                                <small class="block text-gray-600">{{$t('bienvenue.je_souhaite_faire_une_nouvelle_declaration_de_sav')}}</small>
                            </div>
                            <i class="fas fa-caret-right"></i>
                        </div>
                    </router-link>
                    <div v-if="$t('bienvenue.form_details') && $t('bienvenue.form_details') != 'bienvenue.form_details'" class="border-t px-6 pt-6 font-light">
                        {{ $t('bienvenue.form_details') }}
                    </div>
                </template>
                <!-- Welcome standard -->
                <template v-else>
                    <router-link :to="{ name: 'form.home'}" class="text-gray-900" style="text-decoration: none !important;">
                        <div test-id="button-go-to-form" class="flex justify-between items-center border-b p-6 hover:bg-gray-50 rounded-t-xl duration-200">
                            <div class="pr-4">
                                <b>{{$t('bienvenue.nouveau_sav')}}</b>
                                <small class="block text-gray-600">{{$t('bienvenue.je_souhaite_faire_une_nouvelle_declaration_de_sav')}}</small>
                            </div>
                            <i class="fas fa-caret-right"></i>
                        </div>
                    </router-link>
                    <router-link :to="{ name: 'user.login'}" class="text-gray-900" style="text-decoration: none !important;">
                        <div test-id="button-go-to-login" class="flex justify-between items-center p-6 hover:bg-gray-50 rounded-b-xl duration-200">
                            <div>
                                <b>{{$t('bienvenue.me_connecter')}}</b>
                                <small class="block text-gray-600">{{$t('bienvenue.je_possede_deja_un_compte')}}</small>
                            </div>
                            <i class="fas fa-caret-right"></i>
                        </div>
                    </router-link>
                </template>
            </div>
        </div>
    </sav-template>
</template>

<script>
export default {
    mounted() {
        localStorage.removeItem('form-data')

        if (this.$companyTool.confFile().pro_particulier == 2 && this.$route.query.particulier != 1) {
            this.$router.push({name: 'user.login.actors'})
        }        
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/Welcome.vue